import type { FaireProductEntity } from "../../entity_types/product";

export const p_jmp2knjk8m: FaireProductEntity = {
  token: "p_jmp2knjk8m",
  type: "product",
  name: "Tomato Candle",
  brandToken: "b_9vepscyv",
  brandName: "The Neighborgoods",
  imageUrl:
    "https://cdn.faire.com/fastly/cab772d0735a608e4df6e7e449709ef6a2e3bf84fd900608136de8a06acbc590.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/eee4f23475207b7bfe1d61763ff87cfadb7fe13e187eeb3abcec610b646a3ee7.jpeg",
    "https://cdn.faire.com/fastly/adcd2b7fa5b638904c66f8cb156dd451410e41b42aeb2544858b07cc6c38a534.jpeg",
    "https://cdn.faire.com/fastly/2b2fad30ff3bc7a09b511fc03c590222ee59aa9402522038734f70f650301809.jpeg",
    "https://cdn.faire.com/fastly/e05d74f5855deacbeff906dd9f1b70f53a16870637824e452f3873f45242f427.jpeg",
    "https://cdn.faire.com/fastly/1dea31730fc63b7aae55d08bbbaa3a84fbbb529c70a34f7fe3c063a69e48e247.jpeg",
  ],
  priceDollars: 9,
  description:
    'For when you love the idea of growing your own tomatoes, but the only ones thriving in your life are from the farmer\'s market. This candle gives you that fresh-off-the-vine vibe anyway—sweet, earthy, and garden-y.\n\nA true-to-tomato scent infuses this all-natural soy candle, which sits in a reusable sardine-tin–style container. Light this tomato candle for a clean, aromatic burn that\'s perfect for dinner parties, cozy nights in, and everything in between.\n\n\n• 4 oz. sardine-style rectangle tin&nbsp;\n• Approximately 24-hour burn time\n• 100% natural soy wax\n• Custom blended, paraben- and phthalate-free fragrance oils\n• Two lead-free cotton wicks for a clean, even burn\n• Sliding lid stores neatly under the candle when lit\n• Measures 4" x 2.5" x 7/8"\n• Hand-poured locally in Washington, DC by District Candle Lab',
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:44.388Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
